import { render, staticRenderFns } from "./talentsScheme.vue?vue&type=template&id=97bd2374&scoped=true"
import script from "./talentsScheme.vue?vue&type=script&lang=js"
export * from "./talentsScheme.vue?vue&type=script&lang=js"
import style0 from "./talentsScheme.vue?vue&type=style&index=0&id=97bd2374&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bd2374",
  null
  
)

export default component.exports